import { useLocation } from "@tanstack/react-router";
import { useState } from "react";
import { Logo } from "@/components/brand/logo";
import { useSession } from "@/hooks/auth-hooks";
import { ImpersonationBanner } from "../header/ImpersonationBanner";
import { signOutAndNavigate } from "../header/shared";
import { UserMenu } from "../header/UserMenu";

export function DashboardTopBar() {
	const { session, user } = useSession();
	const location = useLocation();
	const isImpersonating = !!session?.impersonatedBy;
	const [isSigningOut, setIsSigningOut] = useState(false);

	if (!user) return null;

	const handleSignOut = async () => {
		if (isSigningOut) return;
		setIsSigningOut(true);
		try {
			await signOutAndNavigate(location.pathname);
		} catch (error) {
			console.error("Sign out failed:", error);
			setIsSigningOut(false);
		}
	};

	return (
		<header className="sticky top-0 z-30 bg-background/95 backdrop-blur-sm">
			<ImpersonationBanner isImpersonating={isImpersonating} user={user} />
			<div className="flex h-14 items-center justify-between px-4 sm:px-6 border-b border-border">
				<div className="lg:hidden">
					<Logo size="sm" />
				</div>
				<div className="hidden lg:block" />
				<div className="flex items-center gap-1.5">
					<UserMenu
						user={user}
						isImpersonating={isImpersonating}
						isSigningOut={isSigningOut}
						onSignOut={() => {
							void handleSignOut();
						}}
					/>
				</div>
			</div>
		</header>
	);
}
